import { Box, CircularProgress, Modal, Pagination } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import UsersApi from "../../../API/UsersApi";
import Sidebar from "../../../Layouts/Sidebar";
import ChangeUserStatusReq from "../../../Requests/Users/ChangeUserStatusReq";
import SearchUserReq from "../../../Requests/Users/SearchUserReq";
import DataTable from "../../../components/Datatable";
import VersatileLoader from "../../../components/VersatileLoader";
import "./index.scss";
import MobileLayout from "../../../Layouts/MobileLayout";
import Layout from "../../../Layouts/Layout";
import { BiLeftArrow, BiRightArrow } from "react-icons/bi";
import { PaginationItem } from "@mui/material";
import { UserContext } from "../../../App";
import QRCode from "qrcode.react";
import { FiEdit2 } from "react-icons/fi";
import { X } from "lucide-react";
import { MdEdit } from "react-icons/md";
import CreateUser from "./component/CreateUser";
const Index = () => {
    const [users, setUsers] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [userType, setUserType] = useState("");
    const [loading, setLoading] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [createUser, setCreateUser] = useState(false);
    const user = useContext(UserContext);

  const navigate = useNavigate();
  const headers = [
    {
      key: "id",
      name: "ID",
    },
    {
      key: "firstName",
      name: "First Name",
    },
    {
      key: "lastName",
      name: "Last Name",
    },
    {
      key: "email",
      name: "Email Address",
    },
    {
      key: "phoneNumber",
      name: "Phone Number",
    },
    {
      key: "address",
      name: "Address",
    },
    {
      key: "userType",
      name: "User Type",
    },

    {
      key: "status",
      name: "Status",
    },
    {
      name: "Commission Details",
      key: "commissionDetails",
    },
    {
      key: "details",
      name: "Details",
    },
    {
      key: "actions",
      name: "Actions",
    },
  ];
  if (user.userType === "SuperAdmin") {
    headers.push({
      key: "title",
      name: "Title",
    });
  }
  if (user.userType === "SuperAdmin") {
    headers.push({
      key: "qrCode",
      name: "QR Code",
    });
  }

  function Button({ onClick, children }) {
    return (
      <button
        style={{
          backgroundImage:
            "linear-gradient(310deg, rgb(33, 82, 255), rgb(33, 212, 253))",
          color: "white",
          padding: "0.5rem 1rem",
          borderRadius: "10px",
        }}
        onClick={() => {
          onClick();
        }}
      >
        {children}
      </button>
    );
  }

  function activateAccount(user, status = "Active") {
    Swal.fire({
      title:
        status === "Active" ? "Activating Account" : "Deactivating Account",
      text: "Please wait...",
      icon: "info",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const req = new ChangeUserStatusReq();
    req.int = user.id;
    req.string = user.status === "Active" ? "Inactive" : "Active";

    req.status = status;

    UsersApi.ChangeUserStatus(req).then((res) => {
      if (res?.status?.success) {
        Swal.fire({
          title:
            status === "Active" ? "Account Activated" : "Account Deactivated",
          text:
            status === "Active"
              ? "The account has been activated."
              : "The account has been deactivated.",
          icon: "success",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showConfirmButton: true,
          didOpen: () => {
            Swal.hideLoading();
          },
        });
        fetchData();
      } else {
        Swal.fire({
          title: "Error",
          text: res?.status?.message,
          icon: "error",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showConfirmButton: true,
          didOpen: () => {
            Swal.hideLoading();
          },
        });
      }
    });
  }

  const [titleModalOpen, setTitleModalOpen] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [selectedTitleUser, setSelectedTitleUser] = useState(null);

  const openTitleModal = (user) => {
    setSelectedTitleUser(user);
    setNewTitle(user.title || "");
    setTitleModalOpen(true);
  };

  const saveTitle = async () => {
    if (!selectedTitleUser) return;

    try {
      const response = await UsersApi.UpdateUserTitle({
        userId: selectedTitleUser.id,
        title: newTitle,
      });

      if (response?.status?.success) {
        Swal.fire("Success", "Title updated successfully", "success");
        fetchData();
        setTitleModalOpen(false);
      } else {
        Swal.fire("Error", response?.status?.message, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const removeTitle = async () => {
    if (!selectedTitleUser) return;

    Swal.fire({
      title: "Are you sure?",
      text: "This will remove the title permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, remove it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await UsersApi.DeleteUserTitle({
            userId: selectedTitleUser.id,
          });

          if (response?.status?.success) {
            Swal.fire("Success", "Title removed successfully", "success");
            fetchData();
            setTitleModalOpen(false);
          } else {
            Swal.fire("Error", response?.status?.message, "error");
          }
        } catch (error) {
          Swal.fire("Error", "Something went wrong", "error");
        }
      }
    });
  };

  function fetchData() {
    setLoading(true);
    let req = new SearchUserReq();
    req.pagingParams.pageNumber = currentPage;
    req.pagingParams.pageSize = 5;
    if (firstName !== "") {
      req.firstName = firstName;
    }
    if (lastName !== "") {
      req.lastName = lastName;
    }
    if (email !== "") {
      req.email = email;
    }
    if (phone !== "") {
      req.phoneNumber = phone;
    }
    if (address !== "") {
      req.address = address;
    }
    if (userType !== "") {
      req.userType = userType;
    }
    req.includeDeactivated = true;
    UsersApi.SearchUser(req).then((res) => {
      if (res?.status?.success) {
        setTotalPages(res?.data?.totalPages);

        const userTemp = [];
        res?.data?.list.map((user, index) => {
          userTemp.push({
            ...user,
            title: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                {user.title ? (
                  <>
                    <div className="flex items-center justify-center gap-2">
                      <span>{user.title}</span>
                      <MdEdit
                        style={{
                          cursor: "pointer",
                          color: "white",
                          background:
                            "linear-gradient(310deg, rgb(33, 82, 255), rgb(33, 212, 253))",
                          borderRadius: "50%",
                          padding: "4px",
                          fontSize: "20px",
                        }}
                        onClick={() => openTitleModal(user)}
                      />
                    </div>
                  </>
                ) : (
                  <Button onClick={() => openTitleModal(user)}>
                    Change Title
                  </Button>
                )}
              </div>
            ),
            actions:
              user.status === "Active" ? (
                <Button
                  onClick={() => {
                    activateAccount(user, "Inactive");
                  }}
                >
                  Deactivate
                </Button>
              ) : (
                <Button onClick={() => activateAccount(user)}>Activate</Button>
              ),

            details: (
              <Button
                onClick={() => {
                  navigate("/searchUser/userDetails", {
                    state: {
                      userId: user.id,
                    },
                  });
                }}
              >
                Details
              </Button>
            ),

            commissionDetails: (
              <Button
                onClick={() => {
                  navigate("/commission-details", {
                    state: {
                      userId: user.id,
                      name: user.firstName + " " + user.lastName,
                    },
                  });
                }}
              >
                Commission Details
              </Button>
            ),
            qrCode: (user.userType === "SalesRep" ||
              user.userType === "SalesOrgAdmin" ||
              user.userType === "SuperAdmin") && (
              <Button
                onClick={() => {
                  setSelectedUser(user);
                  setOpenModal(true);
                }}
              >
                Show QR Code
              </Button>
            ),
          });
        });
        setUsers(userTemp);
        setLoading(false);
      }
    });
  }

  const downloadQrCode = () => {
    const canvas = document.querySelector("canvas");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `${selectedUser?.firstName} ${selectedUser?.lastName} QR Code.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      fetchData();
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const modalStyle = {
    display: "flex",
    justifyContent: "center",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Layout>
      <div className="manageLeadsContainer">
        <div className="manageLeadsHeader">
          <h1 className="manageLeadsTitle">Manage Users</h1>
          <div className="searchFiltersInput">
            <input
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
              onKeyDown={handleKeyPress}
              value={firstName}
              type="text"
              placeholder="FIRST NAME"
            />
            <input
              onChange={(e) => {
                setLastName(e.target.value);
              }}
              onKeyDown={handleKeyPress}
              value={lastName}
              type="text"
              placeholder="LAST NAME"
            />
            <input
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              onKeyDown={handleKeyPress}
              value={phone}
              type="tel"
              placeholder="PHONE"
            />
            <input
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              onKeyDown={handleKeyPress}
              value={email}
              type="email"
              placeholder="EMAIL"
            />
            <input
              onChange={(e) => {
                setAddress(e.target.value);
              }}
              onKeyDown={handleKeyPress}
              value={address}
              type="text"
              placeholder="ADDRESS"
            />
            <select
              value={userType}
              onChange={(e) => {
                setUserType(e.target.value);
              }}
            >
              <option value={""}>USER TYPE</option>
              <option value={"SuperAdmin"}>Super Admin</option>
              <option value={"Admin"}>Admin</option>
              <option value={"SalesOrgAdmin"}>Team Admin</option>
              <option value={"Customer"}>Customer</option>
              <option value={"SalesRep"}>SalesRep</option>
                            <option value={"CustomerServiceRep"}>Customer Service Rep</option>
            </select>
          </div>
          <button
            disabled={loading}
            onClick={() => {
              setCurrentPage(1);
              fetchData();
            }}
          >
            {loading ? "SEARCHING..." : "SEARCH"}
          </button>
          <button onClick={() => setCreateUser(true)}>Create User</button>
        </div>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <VersatileLoader size="large" color="#2761CF" />
          </div>
        ) : (
          <DataTable
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            headers={headers}
            list={users ? users : []}
          />
        )}
        <CreateUser
                    open={createUser}
                    setOpen={setCreateUser}
                    onCreateUser={fetchData} 
                />
        <Modal
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& .modal-content": {
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              textAlign: "center",
              width: "400px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              zIndex: 9999,
            },
            "& .modal-content h3": {
              marginBottom: "20px",
              fontSize: "1.5rem",
              fontWeight: "bold",
              textAlign: "center",
              color: "#181E4B",
            },
            "& .modal-content p": {
              marginBottom: "1rem",
              textDecoration: "underline",
              color: "#4FAFCB",
            },
            "& .modal-content .qr": {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            },
          }}
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="qr-code-modal-title"
          aria-describedby="qr-code-modal-description"
        >
          <div className="modal-content">
            <h3 id="qr-code-modal-title">{`QR Code for ${selectedUser?.firstName} ${selectedUser?.lastName}`}</h3>
            <div className="qr">
              <QRCode
                value={`${window.location.origin}/digital-business-center/${selectedUser?.id}`}
              />
            </div>
            <p onClick={downloadQrCode} style={{ cursor: "pointer" }}>
              Download QRCode
            </p>
            <Button onClick={() => setOpenModal(false)}>Close</Button>
          </div>
        </Modal>
        <Modal open={titleModalOpen} onClose={() => setTitleModalOpen(false)}>
          <div className="bg-white rounded-lg shadow-lg p-6 w-96 mx-auto mt-20 relative">
            <button
              onClick={() => setTitleModalOpen(false)}
              className="absolute top-2 right-2 text-blue-500"
            >
              <X
                size={24}
                className="bg-blue-500 text-white rounded-full p-1"
              />
            </button>
            <div className="flex justify-center mb-4">
              <img
                alt="logo"
                className="object-contain"
                src="/images/nav/nav-logo.png"
              />
            </div>
            <h3 className="text-xl font-semibold text-center">
              Change Title for {selectedTitleUser?.firstName}{" "}
              {selectedTitleUser?.lastName}
            </h3>
            <input
              type="text"
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
              placeholder="Enter new title"
              className="w-full border border-gray-300 rounded px-3 py-2 mt-4 focus:outline-blue-500"
            />
            <div className="mt-4 flex flex-col gap-2">
              {selectedTitleUser?.title ? (
                <>
                  <button
                    onClick={saveTitle}
                    className="bg-blue-500 text-white w-full py-2 rounded-lg"
                  >
                    Update
                  </button>
                  <button
                    onClick={removeTitle}
                    className="bg-red-500 text-white w-full py-2 rounded-lg"
                  >
                    Remove Title
                  </button>
                </>
              ) : (
                <button
                  onClick={saveTitle}
                  className="bg-blue-500 text-white w-full py-2 rounded-lg"
                >
                  Update
                </button>
              )}
            </div>
          </div>
        </Modal>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "1rem ",
          }}
        >
          <Pagination
            color="light"
            renderItem={(item) => (
              <PaginationItem
                components={{
                  next: (props) => (
                    <button {...props}>
                      <BiRightArrow color="var(--color-icon)" />
                    </button>
                  ),
                  first: (props) => <button {...props}>First</button>,
                  previous: (props) => (
                    <button {...props}>
                      <BiLeftArrow color="var(--color-icon)" />
                    </button>
                  ),
                }}
                {...item}
                sx={{ color: "white" }}
              />
            )}
            count={totalPages}
            onChange={(e, pageNo) => {
              setCurrentPage(pageNo);
            }}
          />
        </div>
      </div>
    </Layout>
  );
};

export default Index;
